
import React from "react";
import { Tutorial } from "@/types/tutorial";
import { PartFilter } from "@/data/parts";
import { useTutorialCreator } from "@/hooks/use-tutorial-creator";
import TutorialCreatorLayout from "./TutorialCreatorLayout";
import TutorialCreatorHeader from "./TutorialCreatorHeader";
import TutorialCreatorTabs from "./TutorialCreatorTabs";

interface TutorialCreatorProps {
  onBack: () => void;
  existingTutorial?: Tutorial;
  sidebarExpanded?: boolean;
  toggleSidebar?: () => void;
}

const TutorialCreator: React.FC<TutorialCreatorProps> = ({ 
  onBack, 
  existingTutorial,
  sidebarExpanded = true,
  toggleSidebar 
}) => {
  const {
    tutorial,
    setTutorial,
    selectedPrinters,
    setSelectedPrinters,
    contributors,
    setContributors,
    isSubmitting,
    handleSaveDraft,
    handleSubmitForReview,
    user
  } = useTutorialCreator(existingTutorial);

  // Add requirements state
  const [requirements, setRequirements] = React.useState<PartFilter[]>([]);

  const handleSuccessfulSubmit = async () => {
    const success = await handleSubmitForReview();
    if (success) {
      onBack();
    }
  };

  const editorContentProps = {
    tutorial,
    selectedPrinters,
    contributors,
    requirements,
    isSubmitting,
    isUserLoggedIn: !!user,
    onTitleChange: (title: string) => setTutorial(prev => ({ ...prev, title })),
    onCoverImageChange: (coverImage: string) => setTutorial(prev => ({ ...prev, coverImage })),
    onDescriptionChange: (shortDescription: string) => setTutorial(prev => ({ ...prev, shortDescription })),
    onTagsChange: (tags: string[]) => setTutorial(prev => ({ ...prev, tags })),
    onPrintersChange: setSelectedPrinters,
    onContributorsChange: setContributors,
    onRequirementsChange: setRequirements,
    onBomChange: (bom: any) => setTutorial(prev => ({ ...prev, bom })),
    onSectionsChange: (sections: any) => setTutorial(prev => ({ ...prev, sections })),
    onSaveDraft: handleSaveDraft,
    onSubmitForReview: handleSuccessfulSubmit
  };

  return (
    <TutorialCreatorLayout
      sidebarExpanded={sidebarExpanded}
      sections={tutorial.sections || []}
      bomItemCount={(tutorial.bom || []).length}
      toggleSidebar={toggleSidebar}
    >
      <TutorialCreatorHeader 
        onBack={onBack} 
        existingTutorial={existingTutorial} 
      />
      
      <TutorialCreatorTabs 
        tutorial={tutorial}
        editorContentProps={editorContentProps}
      />
    </TutorialCreatorLayout>
  );
};

export default TutorialCreator;
